// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"643e9ba7","127":"4e209bc0","715":"20fbb8ea"}[chunkId] + ".chunk.js";
};